import * as React from "react";
import { FormComponent } from "../../../../../react-core/Html/FormComponent";
import { WizardLabel, errorStepOne } from "../../Resources/Content";
import { IInvestmentTransfer, ISubInvestment } from "../../Stores/InvestmentTransferStoreStatic";
import { NumberTextBoxEditor } from "../../../../../react-core/Html/NumberTextBoxEditor";
import { SecurityType } from "../../../../../Wrap/Constants/Enums/Domain/Instrument/SecurityType";
import { InvestmentDetails } from "../../../../../Wrap/Models/Domains/Transfer/InvestmentDetails";
import { TransferWizardAction } from "../../Actions/TransferWizardAction";
import { InvestmentTransferQuery } from "../../Resources/TransferInstructionQuery";
import { MoneyDisplayHelper } from "../../../../../react-core/Helpers/MoneyDisplayHelper";
import { PartLoading } from "../../../../../react-core/Html/PartLoading";
import { CommonHelper } from "../../../../../react-core/Helpers/CommonHelper";
import { TransferDestinationAccountModel } from "../../../../../Wrap/Models/Domains/Transfer/TransferDestinationAccountModel";
import { SubAccountType } from "../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { DatePicker } from "../../../../../react-core/Datepicker/DatePicker";
import { ContentDatePicker, ACCEPT_DATE_FORMATS } from "../../../../Shared/Entities/Constants/DateConstants";
import { InvestmentTransferDispatcher, InvestmentTransferStore, MoveableSubAccountStore } from "../../Stores/Variable";
import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { JsonDateParser } from "../../../../../react-core/Utils/JsonDateParser";

interface IInvestmentTableProps extends React.Props<InvestmentTable> {
    onChange: (key: string, value: any, data?: any) => void;
    data: IInvestmentTransfer[];
    destinationAccount: TransferDestinationAccountModel;
    isReview: boolean;
    onRef?: (ref) => void;
}

export class InvestmentTable extends FormComponent<IInvestmentTableProps, null> {
    constructor(props: any) {
        super(props);
    }

    componentDidMount() {
        if (this.props.onRef) {this.props.onRef(this);}
    }

    private renderTheader(type: SubAccountType): JSX.Element {
        const header = Object.values(WizardLabel.InvestmentTable);
        if (type == SubAccountType.InvestmentAccount) {
            const ppHeader = Object.values(WizardLabel.investmentTablePP);
            ppHeader.unshift((header.length - 1).toString(), "0");
            Array.prototype.splice.apply(header, ppHeader);
        }
        return (
            <thead>
                <tr>
                    <th></th>
                    {header.map((ele) => (
                        <th key={`th-${ele}`}>{ele}</th>
                    ))}
                </tr>
            </thead>
        );
    }

    private renderIsMoveAll(data, isReview: boolean, index: number, pIndex?: number) {
        return (
            <td>
                <div className="square-checkbox label-sr-only">
                    <label className="controls-checkbox">
                        <input
                            disabled={isReview}
                            type="checkbox"
                            value="standard"
                            checked={data.isMoveAll}
                            onChange={() => {
                                this.onIsMoveAllChange(index, !data.isMoveAll, pIndex);
                            }}
                        />
                        <span aria-hidden="true" className="gfx" />
                    </label>
                </div>
            </td>
        );
    }

    private renderNullForPP(data, type: SubAccountType, pIndex?: number) {
        if (type !== SubAccountType.InvestmentAccount) {return null;}
        if (
            data.detail.SecurityType == SecurityType.Cash ||
            (data.detail.SecurityType == SecurityType.Model && !pIndex)
        ) {
            return <td />;
        }
        return undefined;
    }

    private renderAmendCost(data, type: SubAccountType, isReview: boolean, index: number, pIndex?: number) {
        const nullDom = this.renderNullForPP(data, type, pIndex);
        if (nullDom !== undefined) {return nullDom;}
        if (isReview) {return <td>{data.amendBookCost ? data.amendBookCost.toString() : ""}</td>;}
        return (
            <td>
                <NumberTextBoxEditor
                    isNotForm={true}
                    // disabled={!data.CGT}
                    value={data.amendBookCost}
                    label={""}
                    onBlur={(v) => {
                        if (v) {
                            this.onChange(index, "amendBookCost", Number(CommonHelper.downFixed(v, 2)), pIndex);
                        }
                    }}
                    validationRules={[
                        {
                            errorMessage: errorStepOne.required,
                            validator: (v) => {
                                return !data.CGT ? true : v ? true : false;
                            },
                        },
                    ]}
                    alwaysValidateOnUpdate={true}
                    onChange={(v) => {
                        this.onChange(index, "amendBookCost", v, pIndex);
                    }}
                />
            </td>
        );
    }

    private renderAcquisitionDate(data, type: SubAccountType, isReview: boolean, index: number, pIndex?: number) {
        const nullDom = this.renderNullForPP(data, type, pIndex);
        if (nullDom !== undefined) {return nullDom;}
        if (isReview)
            {return <td>{data.acquisitionDate ? CommonHelper.formatDate(data.acquisitionDate, "YY/mm/dd") : ""}</td>;}
        return (
            <td>
                <DatePicker
                    width={"w-138"}
                    isNotForm={true}
                    // disabled={!data.CGT}
                    selected={JsonDateParser.toDateNoOffset(data.acquisitionDate)}
                    label={""}
                    showYearDropdown={true}
                    onChange={(v) => {
                        this.onChange(index, "acquisitionDate", JsonDateParser.toJsonDateNoOffset(v), pIndex);
                    }}
                    todayButton={ContentDatePicker.Today}
                    isClearable={true}
                    dateFormat={ContentDatePicker.DateFormat}
                    acceptDateFormats={ACCEPT_DATE_FORMATS}
                    required={data.CGT ? errorStepOne.required : ""}
                    alwaysValidateOnUpdate={true}
                />
            </td>
        );
    }

    private renderCGT(data, type: SubAccountType, isReview: boolean, index: number, pIndex?: number) {
        const nullDom = this.renderNullForPP(data, type, pIndex);
        if (nullDom !== undefined) {return nullDom;}
        return (
            <td>
                <div className="square-checkbox label-sr-only">
                    <label className="controls-checkbox">
                        <input
                            type="checkbox"
                            value="CGT"
                            disabled={isReview || !(data.isMoveAll || data.moveQuantity)}
                            checked={data.CGT}
                            onChange={() => {
                                this.onChange(index, "CGT", !data.CGT, pIndex);
                            }}
                        />
                        <span aria-hidden="true" className="gfx" />
                    </label>
                </div>
            </td>
        );
    }

    private renderQuantity(data, isReview: boolean, index: number, pIndex?: number) {
        if (isReview)
            {return (
                <td>
                    {data.isMoveAll
                        ? CommonHelper.downFixed(data.detail.Quantity, 2)
                        : data.moveQuantity
                        ? data.moveQuantity.toString()
                        : ""}
                </td>
            );}
        if (pIndex == undefined && data.detail.SecurityType == SecurityType.Model) {return <td />;}
        return (
            <td>
                <NumberTextBoxEditor
                    atMost={{
                        errorMessage: `please enter a value between 0 and ${data.detail.Quantity}`,
                        value: data.detail.Quantity,
                    }}
                    atLeast={{
                        errorMessage: `please enter a value between 0 and ${data.detail.Quantity}`,
                        value: 0,
                    }}
                    disabled={data.isMoveAll}
                    isNotForm={true}
                    value={data.isMoveAll ? Number(CommonHelper.downFixed(data.detail.Quantity, 2)) : data.moveQuantity}
                    label={""}
                    onChange={(v) => {
                        this.onChange(index, "moveQuantity", v, pIndex);
                    }}
                    onBlur={(v) => {
                        if (v) {
                            if (data.detail.IsExternalTradedAsset) {
                                this.onChange(index, "moveQuantity", Number(CommonHelper.downFixed(v, 0)), pIndex);
                            } else {
                                this.onChange(index, "moveQuantity", Number(CommonHelper.downFixed(v, 2)), pIndex);
                            }
                        }
                    }}
                />
            </td>
        );
    }

    private onChange(index: number, key: string, value: any, pIndex?: number) {
        const data = this.props.data;

        if (pIndex !== undefined) {
            data[pIndex].subInvestment[index][key] = value;
            // if (key.toLowerCase() == "CGT".toLowerCase()) {
            //     data[pIndex].subInvestment[index].acquisitionDate = null;
            //     data[pIndex].subInvestment[index].amendBookCost = null;
            // }

            if (key.toLowerCase() == "moveQuantity".toLowerCase() && !value) {
                data[pIndex].subInvestment[index].acquisitionDate = null;
                data[pIndex].subInvestment[index].amendBookCost = null;
                data[pIndex].subInvestment[index].CGT = false;
            }
        } else {
            data[index][key] = value;
            // set quantity back to blank when unclick moveall
            // if (key.toLowerCase() == "CGT".toLowerCase()) {
            //     data[index].acquisitionDate = null;
            //     data[index].amendBookCost = null;
            // }

            if (key.toLowerCase() == "moveQuantity".toLowerCase() && !value) {
                data[index].acquisitionDate = null;
                data[index].amendBookCost = null;
                data[index].CGT = false;
            }
        }
        this.onChangeInvestmentData(data);
    }

    private onIsMoveAllChange(index: number, value: any, pIndex?: number) {
        const data = this.props.data;

        //sub investments
        if (pIndex !== undefined) {
            data[pIndex].subInvestment[index]["isMoveAll"] = value;

            if (value == false) {
                data[pIndex].subInvestment[index] = this.emptySubInvestment(data[pIndex].subInvestment[index].detail);
            } else if (
                data[pIndex].subInvestment.filter((i) => i.isMoveAll).length === data[pIndex].subInvestment.length
            ) {
                data[pIndex].isMoveAll = true;
            }
            this.onChangeInvestmentData(data);
        }

        //model investment for the first toggle
        else if (data[index].detail.SecurityType === SecurityType.Model && data[index].isToggle == false) {
            this.onToggle(data[index].detail.InstrumentCode, (subInvestment: ISubInvestment[]) => {
                data[index].subInvestment = subInvestment;
                this.moveAll(data, index, value);
            });
        }
        // individual investment
        else {
            this.moveAll(data, index, value);
        }
    }

    private onChangeInvestmentData(investments: IInvestmentTransfer[]) {
        const investmentData: InvestmentTransferQuery[] = [];
        investments.forEach((ele) => {
            investmentData.push({
                MoveAllAvailable: ele.isMoveAll,
                MoveQuantity: ele.isMoveAll
                    ? ele.detail.SecurityType == SecurityType.Model
                        ? null
                        : ele.detail.Quantity
                    : ele.moveQuantity,
                CgtDate: ele.acquisitionDate,
                CgtExempt: ele.CGT,
                CgtTotalValue: ele.amendBookCost,
                InvestmentCode: ele.detail.InstrumentCode,
                ProductId: ele.detail?.ProductId,
            });
            if (ele.subInvestment) {
                ele.subInvestment.forEach((item) => {
                    investmentData.push({
                        MoveAllAvailable: item.isMoveAll,
                        MoveQuantity: item.isMoveAll ? item.detail.Quantity : item.moveQuantity,
                        InvestmentCode: item.detail.InstrumentCode,
                        ProductId: item.detail?.ProductId,
                        CgtDate: item.acquisitionDate,
                        CgtExempt: item.CGT,
                        CgtTotalValue: item.amendBookCost,
                        ParentModelInstrumentCode: ele.detail.InstrumentCode,
                    });
                });
            }
        });

        this.props.onChange("InvestmentsTransferDetail", investmentData, investments);
    }

    private onToggle(instructionCode: string, callback?: (investment: ISubInvestment[]) => void) {
        const currentInvestment = InvestmentTransferStore.getInvestments();
        const index = currentInvestment.findIndex((ele) => ele.detail.InstrumentCode == instructionCode);
        currentInvestment[index].isToggle = !currentInvestment[index].isToggle;
        if (currentInvestment[index].subInvestment == undefined) {
            TransferWizardAction.getModelPortofoilo(instructionCode, (data) => {
                currentInvestment[index].subInvestment = data.investments.map((ele) => this.emptySubInvestment(ele));

                InvestmentTransferDispatcher.dispatch({
                    actionType: ActionType.Success,
                    payload: currentInvestment,
                });
                if (callback) {
                    callback(currentInvestment[index].subInvestment);
                }
            });
        } else {
            InvestmentTransferDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: currentInvestment,
            });
            if (callback) {
                callback(currentInvestment[index].subInvestment);
            }
        }
    }

    private moveAll(investments: IInvestmentTransfer[], index: number, checked: boolean) {
        // set all child model assets to move all when model asset set move all
        investments[index].isMoveAll = checked;
        if (investments[index].subInvestment) {
            investments[index].subInvestment = investments[index].subInvestment.map((ele) => {
                ele.isMoveAll = checked;
                return ele;
            });
        }

        if (checked == false) {
            this.clearCgtData(investments[index]);
        }
        this.onChangeInvestmentData(investments);
    }

    private clearCgtData(investment: IInvestmentTransfer) {
        investment.moveQuantity = null;
        investment.acquisitionDate = null;
        investment.amendBookCost = null;
        investment.CGT = null;
        if (investment.subInvestment) {
            investment.subInvestment = investment.subInvestment.map((ele) => this.emptySubInvestment(ele.detail));
        }
    }

    private emptySubInvestment(detail?: InvestmentDetails): ISubInvestment {
        return {
            moveQuantity: null,
            acquisitionDate: null,
            detail: detail,
            isMoveAll: false,
            CGT: false,
            amendBookCost: null,
        };
    }

    private renderSubInvestment(
        data: Array<{
            detail: InvestmentDetails;
            isMoveAll: boolean;
            moveQuantity: number;
            amendBookCost: number;
            acquisitionDate: Date;
            CGT: boolean;
        }>,
        type: SubAccountType,
        pIndex: number,
        isReview?: boolean
    ): JSX.Element[] {
        return data.map((ele, index) => {
            return (
                <tr key={`sub-${ele.detail.InstrumentCode}`}>
                    <td />
                    <td>{ele.detail.DisplayName}</td>
                    <td>
                        {MoneyDisplayHelper.FromatMoneyDisplay(
                            ele.detail.MarketValue.Amount,
                            ele.detail.MarketValue.Currency
                        )}
                    </td>
                    <td>{ele.detail.Quantity.toFixed(2)}</td>
                    {this.renderIsMoveAll(ele, isReview, index, pIndex)}
                    {this.renderAmendCost(ele, type, isReview, index, pIndex)}
                    {this.renderAcquisitionDate(ele, type, isReview, index, pIndex)}
                    {this.renderCGT(ele, type, isReview, index, pIndex)}
                    {this.renderQuantity(ele, isReview, index, pIndex)}
                </tr>
            );
        });
    }

    private renderTrow(
        data: IInvestmentTransfer,
        type: SubAccountType,
        index: number,
        isReview?: boolean
    ): JSX.Element {
        return (
            <tr key={`tdata-${index}`}>
                <td>
                    {data.detail.SecurityType == SecurityType.Model ? (
                        <span
                            className={data.isToggle ? "expand-button close mr-0" : "expand-button open mr-0"}
                            onClick={() => this.onToggle(data.detail.InstrumentCode)}
                        />
                    ) : null}
                </td>
                <td>{data.detail.DisplayName}</td>
                <td>
                    {MoneyDisplayHelper.FromatMoneyDisplay(
                        data.detail.MarketValue.Amount,
                        data.detail.MarketValue.Currency
                    )}
                </td>
                <td>{data.detail.Quantity.toFixed(2)}</td>
                {this.renderIsMoveAll(data, isReview, index, undefined)}
                {this.renderAmendCost(data, type, isReview, index, undefined)}
                {this.renderAcquisitionDate(data, type, isReview, index, undefined)}
                {this.renderCGT(data, type, isReview, index, undefined)}
                {this.renderQuantity(data, isReview, index, undefined)}
            </tr>
        );
    }

    private renderTbody(data: IInvestmentTransfer[], type: SubAccountType): JSX.Element {
        if (data.length == 0)
            {return (
                <tbody className="body-split">
                    <tr className="sub-head">
                        <td colSpan={type == SubAccountType.InvestmentAccount ? 9 : 6}>{errorStepOne.noInvesment}</td>
                    </tr>
                </tbody>
            );}
        const rows: JSX.Element[] = [];
        data.forEach((ele, index) => {
            rows.push(this.renderTrow(ele, type, index, this.props.isReview));
            if (ele.isToggle && ele.subInvestment) {
                this.renderSubInvestment(ele.subInvestment, type, index, this.props.isReview).forEach((dom) => {
                    rows.push(dom);
                });
            }
        });
        return <tbody className="body-split">{rows}</tbody>;
    }

    render() {
        const { data } = this.props;
        const currentAccoutType = MoveableSubAccountStore.getCurrentAccount().SubAccountType;

        if (!data)
            {return (
                <PartLoading isLoading={true}>
                    <div className="table-skeleton"></div>
                </PartLoading>
            );}

        return (
            <table className="data-heavy-table">
                {this.renderTheader(currentAccoutType)}
                {this.renderTbody(data, currentAccoutType)}
            </table>
        );
    }
}
